export var ScrollOverflowEnum;
(function (ScrollOverflowEnum) {
    ScrollOverflowEnum["RIGHT"] = "right";
    ScrollOverflowEnum["LEFT"] = "left";
    ScrollOverflowEnum["BOTH"] = "both";
    ScrollOverflowEnum["NONE"] = "none";
})(ScrollOverflowEnum || (ScrollOverflowEnum = {}));
export var ScrollArrowEnum;
(function (ScrollArrowEnum) {
    ScrollArrowEnum["LEFT"] = "left";
    ScrollArrowEnum["RIGHT"] = "right";
})(ScrollArrowEnum || (ScrollArrowEnum = {}));
